<div class="content__inner">
    <header class="content__title">
        <h1>{{ "cameras.list.title" | translate }}</h1>
        <small>{{ "cameras.list.subtitle" | translate }}</small>

        <div class="actions">
            <button *appHasPermission="'CAMERAS.ADD'" (click)="addCamera()" class="btn btn-success btn--icon-text" style="margin-left: 25px"><i class="zmdi zmdi-collection-plus"></i> {{ "cameras.list.add" | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'CAMERAS.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ "cameras.list.card.title" | translate }}</h4>

            <mat-form-field class="search-field">
                <mat-label>{{ "global.datatable.search" | translate }}</mat-label>
                <input matInput [formControl]="pageState.searchInputControl" [autocomplete]="'off'" />
            </mat-form-field>

            <!-- Table -->
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)" [matSortActive]="pageState.sortState.active" [matSortDirection]="pageState.sortState.direction">
                    <ng-container matColumnDef="unverifiedBackofficeRegisteredCamera">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                        <td mat-cell *matCellDef="let row" class="text-center">
                            <i
                                class="unverifiedBackofficeRegisteredCameraIcon zmdi zmdi-cloud-off"
                                *ngIf="row.unverifiedBackofficeRegisteredCamera"
                                [popover]="statusTemplate"
                                [popoverContext]="{ row: row }"
                                placement="bottom"
                                triggers="mouseenter:mouseleave"
                            ></i>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="imei">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.imei" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.imei }}</td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.name" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                    </ng-container>

                    <ng-container matColumnDef="productType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.productType" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.productType }}</td>
                    </ng-container>

                    <ng-container matColumnDef="user">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.user" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.getUser() }}</td>
                    </ng-container>

                    <ng-container matColumnDef="created">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.created" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.created | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="updated">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "cameras.props.updated" | translate }}</th>
                        <td mat-cell *matCellDef="let row">{{ row.updated | date : UTCDATEFORMAT : "+0" }}</td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let row">
                            <div class="d-flex justify-content-end">
                                <i (click)="editCamera(row.productType, row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'CAMERAS.EDIT'"></i>
                                <i (click)="deleteCamera(row.productType, row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'CAMERAS.DELETE'"></i>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator
                class="flex inset-x-0 bottom-0 border-t border-b-0 z-10 bg-gray-50 dark:bg-transparent"
                #paginator
                [length]="pageState.totalRows"
                [pageIndex]="pageState.currentPage"
                [pageSize]="pageState.pageSize"
                [pageSizeOptions]="pageState.pageSizeOptions"
                showFirstLastButtons
                (page)="pageChanged($event)"
            >
            </mat-paginator>
        </div>
    </div>

    <ng-template #statusTemplate let-row="row">
        <div class="status-popover">
            <b>{{ "cameras.props.unverified" | translate }}</b>
        </div>
    </ng-template>
</div>
